import { InjectionToken } from '@angular/core';
import { InitialConfig } from '../interfaces/interfaces';
import { ActivatedRoute } from '@angular/router';

export const INITIAL_CONFIG = new InjectionToken<InitialConfig>(
  'INITIAL_CONFIG'
);

export const initialConfigFactory = (route: ActivatedRoute): InitialConfig => {
  const token = route.snapshot.queryParamMap.get('token') ?? localStorage.getItem('token') as string;
  const country = route.snapshot.queryParamMap.get('country') ?? localStorage.getItem('country') as string;
  localStorage.setItem('token', token);
  localStorage.setItem('country', country);
  return { token, country };
}
